import { map } from 'rxjs/operators';
import { showConfirmModal } from 'src/app/utils/pop_over_maker';
import { MatStepper } from '@angular/material/stepper';
import { RoutingConfig } from 'src/app/utils/routing-config';
import { ToastUtils } from 'src/app/utils/toast_builder';
import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { IonNav, ModalController, PopoverController } from '@ionic/angular';
import { MyPartnersAPI } from '../../../apis/partners.service';
import { Router } from '@angular/router';
import { Preferences } from '@capacitor/preferences';
import { dev } from '../../../config/offlines_keys.json';
import { ModalPartnerComponent } from '../modal-partner/modal-partner.component';
import { PopoverComponent } from 'src/app/widgets/popover/popover.component';
import routes from '../../../config/routing.json';
import { PriorDashboardComponent } from '../../prior-dashboard/prior-dashboard.component';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import Partner from 'src/app/models/partner.model';
import {
  deletePartner,
  loadPartner,
  loadPartnerType,
} from 'src/app/utils/states-management/actions/partner.action';
import { take } from 'rxjs';
import { selectAllPartners } from 'src/app/utils/states-management/selector/partners.selector';
import Owner from 'src/app/models/owner.model';
import { cloneDeep } from 'lodash';
import { connectionStatus } from 'src/app/utils/states-management/reducers/offline.reducer';
@Component({
  selector: 'app-partner-view-one',
  templateUrl: './partner-view-one.component.html',
  styleUrls: ['./partner-view-one.component.scss'],
  providers: [MyPartnersAPI],
})
export class PartnerViewOneComponent implements OnInit {
  langage_package;
  title;
  partner_add_btn;
  owner_id: number;
  titlemodal: string;
  next;
  return;
  bubble_desc;
  isDashboardView;
  @Input() nav: IonNav;
  @Input() rootStack;
  @Input() cropProduct;
  @Input('steps') steps: MatStepper;
  cropId;
  base_url = environment.appRoot;
  constructor(
    public modalController: ModalController,
    private router: Router,
    public translateService: TranslateService,
    private partnerAPI: MyPartnersAPI,
    private toastUtils: ToastUtils,
    private routingConfig: RoutingConfig,
    private popover: PopoverController,
    private store: Store<{ partners: Partner; owner: Owner }>
  ) {
    this.store.dispatch(loadPartnerType());
    this.store.dispatch(loadPartner());

  }

  async presentModal() {
    let modal = await this.toastUtils.modalBuilder(
      ModalPartnerComponent,
      {
        cropProduct: this.cropProduct,
      },

      ['my-custom-modal-css ', 'modal-wrapper']
    );

    modal.onDidDismiss().then(() => this.get_partners());
  }
  async presentupdateModal(item) {
    let modal = await this.toastUtils.modalBuilder(
      ModalPartnerComponent,
      { item: item, cropProduct: this.cropProduct },
      ['my-custom-modal-css ', 'modal-wrapper']
    );

    modal.onDidDismiss().then(() => this.get_partners());
  }
  list = {} as any;
  cropLabel = '';
  async getowner_id() {
    this.store
      .select('owner')
      .pipe(take(1))
      .subscribe((value) => (this.owner_id = value.id));
  }
  nextUrl;
  backUrl;
  async ngOnInit() {
    await this.langageChanger();
    [this.nextUrl, this.backUrl] = await Promise.all([
      this.routingConfig.getNextUrl(),
      this.routingConfig.getBackUrl(),
    ]);
    this.translateService.onLangChange.subscribe(async (value) => {
      await this.langageChanger();
    });
    this.store.select(connectionStatus).subscribe((val: boolean) => {
      this.isOnline = val;
    });
    await this.getowner_id();
    this.get_partners();
    this.isDashboardView = this.router.url.includes(routes.dashboard.home);

  }
  async mnext() {
    this.router.navigateByUrl(await this.routingConfig.getNextUrl());
  }
  async mback() {
    this.router.navigateByUrl(await this.routingConfig.getBackUrl());
  }
  async showPopOver() {
    let componentProps = { key1: this.bubble_desc };

    await this.toastUtils.popOverBuilder(
      componentProps,
      PopoverComponent,
      'popover-custom'
    );
  }
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (!this.isDashboardView && this.steps?.selectedIndex === 1) {
      this.showPopOver();
    }
  }
  async langageChanger() {
    this.next = await this.translateService.instant('next');
    this.return = await this.translateService.instant('return');
    this.title = await this.translateService.instant('titles.partner_list_title');
    if (this.translateService.currentLang == 'fr') {
      this.cropProduct.id == 1
        ? (this.title += ' vos')
        : this.cropProduct.id == 16
          ? (this.title += ' votre')
          : '';
    }

    this.bubble_desc = await this.translateService
      .instant('bubble_desc_partner');
  }
  get_partners() {
    this.store.select('partners').subscribe((value: any) => {
      // this.list = [];

      // Group partners by partner_type_id
      this.list = cloneDeep(Object.values(value?.entities)).reduce((groups: any, partner: any) => {
        const typeId = partner?.partner_type?.id || 'undefined';
        if (!groups[typeId]) {
          groups[typeId] = {
            partners: [],
            isOpen: true
          };
        }
        groups[typeId].partners.push(partner);
        return groups;
      }, {});

      // Convert grouped object to array format
      // Object.values(groupedPartners).forEach((partners: any) => {
      //   this.list.push(...partners);
      // });
      // console.log(groupedPartners)
    });
  }
  onTypeClicked(typeId: string) {
    this.list[typeId]['isOpen'] = !this.list[typeId]['isOpen'];
  }
  isOnline: boolean = true;

  async delete(id: number) {
    // Handle offline mode
    if (!this.isOnline) {
      this.store.dispatch(deletePartner({ id }));
      return;
    }

    try {
      // Get translations in parallel for better performance
      const [confirmMessage, confirmButton, cancelButton] = await Promise.all([
        this.translateService.instant('confirm_delete_buyer'),
        this.translateService.instant('confirm'),
        this.translateService.instant('cancel')
      ]);

      // Show confirmation modal
      const modal = await showConfirmModal(
        this.popover,
        confirmMessage,
        null,
        confirmButton,
        cancelButton
      );

      // Wait for user response
      const { data } = await modal.onWillDismiss();

      // Delete partner if confirmed
      if (data?.confirmed) {
        this.store.dispatch(deletePartner({ id }));
      }
    } catch (error) {
      console.error('Error during partner deletion process:', error);
    }
  }

  updateForm(id) {
    this.presentupdateModal(id);
  }


  returnToDashboard() {
    this.nav.setRoot(this.rootStack, {
      nav: this.nav,
      rootStack: PriorDashboardComponent,
    });
  }
}